import { TIME_TRACKING_TIME_FORMAT } from '@app/constants';
import { Locale } from '@app/types/translatable.type';
import moment from 'moment';
import { Settings } from '../interfaces/settings.interface';

export function generateTimeIntervals(
    locale: Locale,
    settings?: Settings,
    hasTimeClockTimer?: boolean
): { value: string; label: string }[] {
    const intervalMinutes =
        settings?.allowTimeClockRounding && hasTimeClockTimer ? (settings.timeClockRoundingMinutes ?? 15) : 15;

    // Calculate how many intervals in a day (24 * 60 / intervalMinutes)
    const totalIntervals = Math.floor(1440 / intervalMinutes);

    return Array.from({ length: totalIntervals }, (_, i) =>
        moment()
            .startOf('day')
            .add(i * intervalMinutes, 'minutes')
    ).map((time) => ({
        value: time.format(TIME_TRACKING_TIME_FORMAT.en_CA), // Always store the English format in the BE
        label: time.format(TIME_TRACKING_TIME_FORMAT[locale]), // Display according to the user's locale
    }));
}
